export default "__VITE_ASSET__34f66255__"